export default __webpack_public_path__ + "static/media/commonsplace-logo.46fe5f2a.jpg";